// material ui
import { Theme } from '@mui/material';

export const listCustomization = {
  MuiListItem: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.selected,
          },
        },
        // border: '1px solid',
        // borderColor: theme.palette.divider,
        borderRadius: 8,
      }),
    },
  },
};
